import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  createWithdrawalsRequest: ['salesforce_contact_id'],
	createWithdrawalsSuccess: ['dataWithdrawals'],
	createWithdrawalsFailure: null,
	clearWithdrawalData: null
});

export const CreateWithdrawalTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
	fetching: false,
	dataWithdrawals: null,
	error: null,
  salesforce_contact_id: null
});

export const CreateWithdrawalsSelectors = {
  getData: (state: any) => state.createWithdrawals.data,
  isFetching: (state: any) => state.createWithdrawals.fetching,
  isSuccess: (state: any) => state.createWithdrawals.success,
  hasError: (state: any) => state.createWithdrawals.error,
  getDataWithdrawals: (state: any) => state.createWithdrawals.dataWithdrawals,
  getSalesforceContactId: (state: any) => state.createWithdrawals.salesforce_contact_id,
};

export const request = (state: any, { salesforce_contact_id }: any) => {
  console.log('CreateWithdrawalRedux: Request reducer called with:', { salesforce_contact_id });
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    dataWithdrawals: null,
    salesforce_contact_id: salesforce_contact_id,
  };
  const newState = state.merge ? state.merge(updateData) : { ...state, ...updateData };
  console.log('CreateWithdrawalRedux: New state after request:', newState);
  return newState;
};

export const success = (state: any, action: any) => {
  const { dataWithdrawals } = action;
  console.log('CreateWithdrawalRedux: Success reducer called with:', { dataWithdrawals, action });
  console.log('CreateWithdrawalRedux: dataWithdrawals structure:', {
    hasId: !!dataWithdrawals?.id,
    id: dataWithdrawals?.id,
    hasData: !!dataWithdrawals?.data,
    dataId: dataWithdrawals?.data?.id,
    fullStructure: dataWithdrawals
  });
  
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    dataWithdrawals,
  };
  const newState = state.merge ? state.merge(updateData) : { ...state, ...updateData };
  console.log('CreateWithdrawalRedux: New state after success:', newState);
  return newState;
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    dataWithdrawals: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const clear = (state: any) => {
  console.log('CreateWithdrawalRedux: Clear reducer called, resetting state');
  const updateData = {
    fetching: false,
    success: false,
    error: false,
    dataWithdrawals: null,
    salesforce_contact_id: null,
  };
  const newState = state.merge ? state.merge(updateData) : { ...state, ...updateData };
  console.log('CreateWithdrawalRedux: New state after clear:', newState);
  return newState;
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CREATE_WITHDRAWALS_REQUEST]: request,
	[Types.CREATE_WITHDRAWALS_SUCCESS]: success,
	[Types.CREATE_WITHDRAWALS_FAILURE]: failure,
	[Types.CLEAR_WITHDRAWAL_DATA]: clear
});
